import module from 'nominas/sumario/module.js'

const schema = {
  fecha: 'date',
  fecha_final: 'date',
  fecha_inicial: 'date',
  fecha_pago: 'date',
  id_moneda: 'number',
  id_regimen_fiscal: 'number',
  id_tipo_nomina: 'number',
  tipo_cambio: 'number',
  tipo_cambio_fecha: 'date',
  no_deducible: 'boolean',
  aplicar_ajuste_impuesto: 'boolean',
}

export class NominasSumarioAgregarService {
  constructor ($http, $q) {
    this.$http = $http
    this.$q = $q
  }

  post (idProyecto, data, duplicar) {
    return this.$http.post('/api/nominas', data, {
      params: {id_proyecto: idProyecto, duplicar: duplicar},
      schema,
    })
  }
}

module.service('NominasSumarioAgregar', NominasSumarioAgregarService)



// WEBPACK FOOTER //
// ./src/nominas/sumario/services/NominasSumarioAgregar.js